import { List, Map } from 'immutable'
import { browserHistory } from 'react-router'

import unitService from '../services/unit'

const FETCH_ALL = 'admin/unit/FETCH_ALL'
const FETCH_ALL_SUCCESS = 'admin/unit/FETCH_ALL_SUCCESS'

const CREATE_UNIT = 'admin/unit/CREATE_UNIT'
const CREATE_UNIT_SUCCESS = 'admin/unit/CREATE_UNIT_SUCCESS'
const CREATE_UNIT_FAILURE = 'admin/unit/CREATE_UNIT_FAILURE'

const EDIT_UNIT = 'admin/unit/EDIT_UNIT'
const EDIT_UNIT_SUCCESS = 'admin/unit/EDIT_UNIT_SUCCESS'
const EDIT_UNIT_FAILURE = 'admin/unit/EDIT_UNIT_FAILURE'

const DELETE_UNIT = 'admin/unit/DELETE_UNIT'
const DELETE_UNIT_SUCCESS = 'admin/unit/DELETE_UNIT_SUCCESS'
const DELETE_UNIT_FAILURE = 'admin/unit/DELETE_UNIT_FAILURE'

const PAGINATE_UNITS = 'admin/unit/PAGINATE'

const defaultState = Map({
  units: List(),
  deletedUnits: List(),
  pagination: null,
  isLoading: false
})

export default function unitAdminReducer(state = defaultState, action = undefined) {
  switch (action.type) {
    case FETCH_ALL:
      return state.update('isLoading', () => true)

    case FETCH_ALL_SUCCESS:
      return state.update('isLoading', () => false).update('units', () => action.payload)

    case DELETE_UNIT_SUCCESS:
      return state.update('deletedUnits', deleted => deleted.push(action.payload.uuid))

    case PAGINATE_UNITS:
      return state.update('pagination', () => action.payload)

    default:
      return state
  }
}

export function getUnits(organisationId, page) {
  return dispatch => {
    dispatch({ type: FETCH_ALL, payload: null })
    dispatch({ type: PAGINATE_UNITS, payload: null })

    return unitService.getAllUnits(organisationId, page).then(response => {
      const units = response.data.units.map(value => ({
        ...value.unit,
        wopi360Count: value.wopi360Count
      }))

      dispatch({ type: FETCH_ALL_SUCCESS, payload: List(units) })
      dispatch({ type: PAGINATE_UNITS, payload: response.data.pagination })
    })
  }
}

export function createUnit(organisationId, createInput) {
  return dispatch => {
    dispatch({ type: CREATE_UNIT, payload: null })

    unitService
      .createUnit(organisationId, createInput)
      .then(response => {
        dispatch({ type: CREATE_UNIT_SUCCESS, payload: response.data })

        browserHistory.push(`/units/${response.data.uuid}`)
      })
      .catch(e => dispatch({ type: CREATE_UNIT_FAILURE, payload: e }))
  }
}

export function editUnit(organisationId, uuid, editInput) {
  return dispatch => {
    dispatch({ type: EDIT_UNIT, payload: null })

    unitService
      .editUnit(organisationId, uuid, editInput)
      .then(response => {
        dispatch({ type: EDIT_UNIT_SUCCESS, payload: response.data })

        browserHistory.push(`/units/${response.data.uuid}`)
      })
      .catch(e => dispatch({ type: EDIT_UNIT_FAILURE, payload: e }))
  }
}

export function deleteUnit(organisationId, uuid) {
  return dispatch => {
    dispatch({ type: DELETE_UNIT })

    return unitService
      .deleteUnit(organisationId, uuid)
      .then(() => dispatch({ type: DELETE_UNIT_SUCCESS, payload: { uuid } }))
      .catch(e => dispatch({ type: DELETE_UNIT_FAILURE, payload: e }))
  }
}



// WEBPACK FOOTER //
// ./src/ducks/unit-admin.js